import { useAbility } from '@casl/react';

/**
 * Custom hook to get the ability to check user permissions
 * @returns The ability to check user permissions
 */
const useContextualAbility = () => {
  return useAbility();
};

export { useContextualAbility };
